(function () {
  'use strict';

  var apiName = 'CardcomplexRelatedCollectionShadows';
  var WRAPPER_SELECTOR = '[data-related-shadow]';
  var SCROLLER_SELECTOR = '[data-related-scroller]';

  var updateFrame = 0;
  var initFrame = 0;
  var mutationObserver = null;
  var resizeObserver = null;
  var pendingWrappers = new Set();
  var boundScrollers = new WeakSet();
  var observedScrollers = new WeakSet();

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function getWrapper(scroller) {
    if (!scroller || !scroller.closest) return null;
    return scroller.closest(WRAPPER_SELECTOR);
  }

  function normalizedScrollLeft(scroller) {
    return Math.max(0, Number(scroller.scrollLeft) || 0);
  }

  function measureWrapper(wrapper) {
    if (!wrapper || !wrapper.isConnected) return null;

    var scroller = wrapper.querySelector(SCROLLER_SELECTOR);
    if (!scroller) return null;

    var scrollWidth = Math.ceil(scroller.scrollWidth);
    var clientWidth = Math.floor(scroller.clientWidth);
    var scrollLeft = normalizedScrollLeft(scroller);
    var maxScrollLeft = Math.max(0, scrollWidth - clientWidth);

    var overflowTolerance = 3;
    var edgeTolerance = 4;
    var hasOverflow = maxScrollLeft > overflowTolerance;

    return {
      wrapper: wrapper,
      hasOverflow: hasOverflow,
      isAtStart: !hasOverflow || scrollLeft <= edgeTolerance,
      isAtEnd:
        !hasOverflow ||
        scrollLeft >= Math.max(0, maxScrollLeft - edgeTolerance)
    };
  }

  function applyMeasurement(state) {
    if (!state || !state.wrapper) return;

    state.wrapper.classList.toggle('has-overflow', state.hasOverflow);
    state.wrapper.classList.toggle('is-at-start', state.isAtStart);
    state.wrapper.classList.toggle('is-at-end', state.isAtEnd);
  }

  function flushUpdates() {
    updateFrame = 0;

    var wrappers = Array.from(pendingWrappers);
    pendingWrappers.clear();

    var measurements = wrappers.map(measureWrapper).filter(Boolean);
    measurements.forEach(applyMeasurement);
  }

  function scheduleWrapperUpdate(wrapper) {
    if (!wrapper) return;

    pendingWrappers.add(wrapper);

    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(flushUpdates);
  }

  function scheduleAllUpdates() {
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(function (wrapper) {
      pendingWrappers.add(wrapper);
    });

    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(flushUpdates);
  }

  function onScroll(event) {
    scheduleWrapperUpdate(getWrapper(event.currentTarget));
  }

  function observeScroller(scroller) {
    if (!resizeObserver || observedScrollers.has(scroller)) return;

    resizeObserver.observe(scroller);
    observedScrollers.add(scroller);
  }

  function bindScroller(scroller) {
    if (!scroller) return;

    var wrapper = getWrapper(scroller);

    if (!boundScrollers.has(scroller)) {
      scroller.addEventListener('scroll', onScroll, { passive: true });
      boundScrollers.add(scroller);
    }

    observeScroller(scroller);
    scheduleWrapperUpdate(wrapper);

    scroller.querySelectorAll('img').forEach(function (image) {
      if (image.complete) return;

      image.addEventListener('load', scheduleAllUpdates, { once: true });
      image.addEventListener('error', scheduleAllUpdates, { once: true });
    });
  }

  function bindScope(scope) {
    var root = scope || document;
    var scrollers = [];

    if (root.matches && root.matches(SCROLLER_SELECTOR)) {
      scrollers.push(root);
    }

    if (root.querySelectorAll) {
      scrollers = scrollers.concat(
        toArray(root.querySelectorAll(SCROLLER_SELECTOR))
      );
    }

    scrollers.forEach(bindScroller);
  }

  function runInit(scope) {
    bindScope(scope || document);
    scheduleAllUpdates();
  }

  function scheduleInit(scope) {
    if (initFrame) return;

    initFrame = window.requestAnimationFrame(function () {
      initFrame = 0;
      runInit(scope || document);
    });
  }

  function containsRelevantContent(node) {
    if (!node || node.nodeType !== 1) return false;

    if (
      node.matches &&
      node.matches(WRAPPER_SELECTOR + ', ' + SCROLLER_SELECTOR + ', #ProductGridContainer')
    ) {
      return true;
    }

    return Boolean(
      node.querySelector &&
      node.querySelector(WRAPPER_SELECTOR + ', ' + SCROLLER_SELECTOR)
    );
  }

  function startMutationObserver() {
    if (mutationObserver || !document.body) return;

    mutationObserver = new MutationObserver(function (mutations) {
      var shouldRebind = mutations.some(function (mutation) {
        return toArray(mutation.addedNodes).some(containsRelevantContent);
      });

      if (shouldRebind) {
        scheduleInit(document);
      }
    });

    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function startResizeObserver() {
    if (resizeObserver || !('ResizeObserver' in window)) return;

    resizeObserver = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        scheduleWrapperUpdate(getWrapper(entry.target));
      });
    });
  }

  function init() {
    startResizeObserver();
    bindScope(document);
    startMutationObserver();

    scheduleAllUpdates();
    window.requestAnimationFrame(scheduleAllUpdates);
    window.setTimeout(scheduleAllUpdates, 120);
    window.setTimeout(scheduleAllUpdates, 450);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready
        .then(scheduleAllUpdates)
        .catch(function () {});
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target &&
        event.target.closest &&
        event.target.closest(
          'facet-filters-form, #FacetFiltersForm, #FacetSortForm, #FacetFiltersFormMobile, .facets'
        )
      ) {
        scheduleInit(document);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      if (
        event.target &&
        event.target.closest &&
        event.target.closest(
          'facet-remove, .active-facets__button, .active-facets__button-remove, .facets__reset, .pagination__item'
        )
      ) {
        scheduleInit(document);
      }
    },
    true
  );

  window.addEventListener('resize', scheduleAllUpdates, { passive: true });
  window.addEventListener('orientationchange', scheduleAllUpdates, {
    passive: true
  });
  window.addEventListener('pageshow', scheduleAllUpdates, { passive: true });
  window.addEventListener(
    'popstate',
    function () {
      scheduleInit(document);
    },
    { passive: true }
  );

  document.addEventListener('shopify:section:load', function (event) {
    scheduleInit(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    scheduleInit(document);
  });

  window[apiName] = {
    init: init,
    update: scheduleAllUpdates
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
